import React from "react";
import TableRowCard from "./table.row.card";

const TableCard = ({classification, items, isAsset, isLiability, years, onItemClick}) => {

  const currentYear = new Date().getFullYear();
  const futureYear = currentYear + (years || 0);
  const term = "";

  const formatTermRemaining = (term_years, term_months, forecastYears) => {

    

    const termRemaining = (term_years + term_months / 12) - forecastYears;

    if (termRemaining <= 0) return "Fully repaid";

    const remainingYears = Math.floor(termRemaining);
    const remainingMonths = Math.round((termRemaining - remainingYears) * 12);

    if (remainingYears < 1) {
      const monthText = remainingMonths === 1 ? "month" : "months";
      return `${remainingMonths} ${monthText} remaining`;
    }

    const yearText = remainingYears === 1 ? "year" : "years";
    if (remainingMonths === 0) return `${remainingYears} ${yearText} `;
    const monthText = remainingMonths === 1 ? "month" : "months";
    return `${remainingYears} ${yearText} ${remainingMonths} ${monthText} `;
  };

  const calculateProjection = (item, forecastYears, isAsset) => {
    const t = forecastYears || 0;
    const principal = Math.abs(item.valuation) * (item.ownership / 100);

    if (isAsset) {
      // Asset projection with compound interest and contributions
      const rate = (item.annual_growth || 0) / 100;
      const contributions = item.annual_contributions || 0;

      let futureValue;
      if (rate === 0) {
        // If no growth, just add contributions over time
        futureValue = principal + contributions * t;
      } else {
        // FV = P(1+r)^t + C * [((1+r)^t - 1) / r]
        futureValue = Math.round(principal * Math.pow(1 + rate, t) + contributions * ((Math.pow(1 + rate, t) - 1) / rate));
      }
      return futureValue;
    } else {
      // Liability projection with amortization
      const interestRate = (item.interest_rate || 0) / 100;
      const termYears = item.term_years || 0;
      const termMonths = item.term_months || 0;
      const totalTermYears = termYears + termMonths / 12;

      let futureValue;

      if (totalTermYears > 0 && t >= totalTermYears) {
        // Term has expired — debt is settled regardless of repayment status
        futureValue = 0;
      } else if (!item.being_repaid) {
        // Not being repaid within the term — stays at current value
        futureValue = principal;
      } else if (interestRate === 0) {
        // Simple linear paydown with no interest
        futureValue = principal * (1 - t / totalTermYears);
      } else {
        // Calculate monthly payment using amortization formula
        const monthlyRate = interestRate / 12;
        const numPayments = totalTermYears * 12;
        const monthlyPayment = (principal * (monthlyRate * Math.pow(1 + monthlyRate, numPayments))) / (Math.pow(1 + monthlyRate, numPayments) - 1);

        // Calculate remaining balance after t years
        const paymentsRemaining = numPayments - t * 12;
        if (paymentsRemaining <= 0) {
          futureValue = 0;
        } else {
          futureValue = Math.round((monthlyPayment * (Math.pow(1 + monthlyRate, paymentsRemaining) - 1)) / (monthlyRate * Math.pow(1 + monthlyRate, paymentsRemaining)));
        }
      }
      return futureValue;
    }
  };

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="card">
    <div className="table-group">
      <div className="table-row">
        <div className="flex col">
          <p className="small ">{classification}</p>
        </div>

        <div className="flex col center">
          <p className="small ">
            {isAsset && "Annual growth"}
            {isLiability && "Interest rate"}
          </p>
        </div>


    <div className="flex col center">
          <p className="small ">
            {isAsset && "Annual contribution"}
            {isLiability && "Term left"}
          </p>
        </div>

        <div className="flex col end">
          <p className="small ">
            {isAsset && "Forecast"}
            {isLiability && "Debt left"}
          </p>
        </div>
      </div>
      </div>

      <div className=" table-group margin-top-large">
        {items.map((item, index) => (
          <TableRowCard key={item.id || index} item={item} index={index} isAsset={isAsset} isLiability={isLiability} years={years} onItemClick={onItemClick} calculateProjection={calculateProjection} formatTermRemaining={formatTermRemaining} />
        ))}
      </div>
    </div>
  );
};

export default TableCard;
